(() => {
  const dialog = document.getElementById('yeaday-email-popup');
  if (!dialog || !dialog.showModal) return;
  const key = 'yeaday:' + dialog.dataset.market + ':email-popup:v1';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; }
  };
  const save = (state) => {
    try { localStorage.setItem(key, JSON.stringify(state)); } catch {}
  };
  let previousFocus;
  let timer;
  const open = () => {
    clearTimeout(timer);
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('yeaday-popup-open');
  };
  const dismiss = () => {
    save({ ...read(), dismissedUntil: Date.now() + 7 * 86400000 });
    dialog.close();
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-yeaday-popup-open]')) {
      event.preventDefault();
      open();
    }
  });
  dialog.querySelectorAll('[data-yeaday-popup-close]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('yeaday-popup-open');
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dismiss();
  });
  const offerToggle = dialog.querySelector('[data-yeaday-offer-toggle]');
  const offerTerms = dialog.querySelector('#YeadayPopupOfferTerms');
  if (offerToggle && offerTerms) {
    offerToggle.addEventListener('click', () => {
      offerTerms.hidden = !offerTerms.hidden;
      offerToggle.setAttribute('aria-expanded', String(!offerTerms.hidden));
    });
  }
  const form = dialog.querySelector('form');
  const email = dialog.querySelector('input[type="email"]');
  const error = dialog.querySelector('#YeadayEmailPopupError');
  const submit = dialog.querySelector('[data-yeaday-popup-submit]');
  let loadingTimer;
  const resetLoading = () => {
    clearTimeout(loadingTimer);
    submit?.removeAttribute('aria-busy');
    const spinner = submit?.querySelector('.yeaday-popup__spinner');
    if (spinner) spinner.hidden = true;
  };
  email?.addEventListener('invalid', event => {
    event.preventDefault();
    email.setAttribute('aria-invalid', 'true');
    error.textContent = 'Please enter a valid email address.';
    error.hidden = false;
    resetLoading();
    email.focus();
  });
  email?.addEventListener('input', () => {
    email.removeAttribute('aria-invalid');
    error.hidden = true;
    resetLoading();
  });
  form?.addEventListener('submit', () => {
    if (!submit) return;
    submit.setAttribute('aria-busy', 'true');
    submit.querySelector('.yeaday-popup__spinner').hidden = false;
    // Native Shopify submission and its CAPTCHA keep control of the request.
    loadingTimer = setTimeout(resetLoading, 15000);
  });
  window.addEventListener('pageshow', resetLoading);
  dialog.addEventListener('close', resetLoading);
  dialog.querySelector('[data-yeaday-popup-copy]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const status = dialog.querySelector('[data-copy-status]');
    const code = dialog.querySelector('[data-yeaday-popup-code]').textContent.trim();
    try {
      await navigator.clipboard.writeText(code);
      button.querySelector('[data-copy-label]').textContent = 'Copied!';
      button.querySelector('[data-copy-icon]').hidden = true;
      button.querySelector('[data-copied-icon]').hidden = false;
      status.textContent = 'Code copied.';
    } catch {
      status.textContent = 'Copy was unavailable. Select and copy the code above.';
    }
  });
  if (dialog.dataset.success === 'true') {
    save({ ...read(), subscribed: true });
    open();
    return;
  }
  if (dialog.dataset.errors === 'true') { open(); return; }
  const autoOpen = () => {
    const state = read();
    if (dialog.dataset.home !== 'true' || dialog.dataset.subscribed === 'true' || state.subscribed || Date.now() < Number(state.dismissedUntil || 0)) return;
    if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]')) return;
    open();
  };
  if (document.readyState === 'complete') timer = setTimeout(autoOpen, 5000);
  else window.addEventListener('load', () => { timer = setTimeout(autoOpen, 5000); }, { once: true });
})();
